import { Box, Typography, styled } from "@mui/material";
import AvatarSelectionCard from "../cards/AvatarSelectionCard";
import { useTranslation } from "react-i18next";

const PageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  overflowY: "auto",
}));

const Title = styled(Typography)(() => ({
  fontSize: "2.5rem",
  fontWeight: 700,
  color: "#002e5a",
  marginBottom: "2rem",
  marginTop: "1rem",
  textAlign: "center",
}));

const AvatarSelectionPage = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <Title>{t("Avatar & Praxisfokus")}</Title>
      <AvatarSelectionCard />
    </PageContainer>
  );
};

export default AvatarSelectionPage;
